module.exports = __webpack_public_path__ + "img/h5-2.9f4f5dec.png";